var dialogs = angular.module('dialogs', ['ui.bootstrap.modal']);




